import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchCollections = createAsyncThunk('collections/fetchCollections', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}rest/entities/Collections`);
  return response.data;
});

const collectionSlice = createSlice({
  name: 'collections',
  initialState: {
    collections: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCollections.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.collections = action.payload;
      })
      .addCase(fetchCollections.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default collectionSlice.reducer;
